module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("To sad endings and new beginnings")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_vm._v("In memory of a dear friend and colleague, Fiona.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("The world lost a little bit of its sparkle when you passed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("You are missed every day.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_vm._v("And to my good friends, Mr & Mrs Smith, AKA The Smervs.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("You are perfect together and I wish you every happiness for the future.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 72
// module chunks = 0